import { lazy } from 'react'

export const RefreshConnectionPageLazy = lazy(() => import('./RefreshConnectionPopup'))
